/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

/**
 * Types of invoices supported by the system
 */
export enum EnumBillingCounter {
    /**
     * A normal invoice
     */
    Invoice = 1,
    /**
     * Credit note
     */
    CreditNote = 2,
    /**
     * Cancellation to a previous invoice or credit
     */
    Cancellation = 3,
    /**
     * Cash journal
     */
    CashJournal = 4,
    /**
     * Cash journal entry
     */
    CashJournalPosition = 5,
    /**
     * Cash invoice
     */
    CashInvoice = 6,
    /**
     * Cash Credit note
     */
    CashCreditNote = 7,
    /**
     * Cash Cancellation Counter
     */
    CashCancellation = 8,
    /**
     * Draft invoice
     * 
     * Given to invoices before they are approved.
     */
    DraftInvoice = 9,
}
